// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + ({"176":"projects","783":"sites","6842":"map"}[chunkId] || chunkId) + "." + {"176":"68e0c48f","783":"23408bf8","2912":"e430e7bb","6842":"4662b106","6971":"a124fcf9"}[chunkId] + ".css";
};